import { BaseAPI } from '../BaseApi';
import { eAPITags } from '../eAPITags';
import { IClientCompaniesQuery } from '../../types/clients/ClientCompaniesQuery';
import { IUpdateClientCompanyRequest } from '../../types/clients/IUpdateClientCompanyRequest';
import { IClientCompanyData } from '../../ui-toolkit/orders/interfaces/IClient';

export const ClientCompanyApi = BaseAPI.injectEndpoints({
  endpoints: (build) => ({
    listClients: build.query<IClientCompanyData[], IClientCompaniesQuery>({
      query: (clientCompaniesQuery) => {
        return {
          url: '/timber/api/internal/client_companies',
          params: clientCompaniesQuery,
        };
      },
      providesTags: (response, error, params) => [
        ...(response ?? []).map((company) => ({ type: eAPITags.ClientCompanyData, id: company.id })),
        { type: eAPITags.ClientCompanyData, id: 'LIST' },
      ],
    }),
    updateClient: build.mutation<IClientCompanyData, IUpdateClientCompanyRequest>({
      query: ({ id, isActive }) => ({
        url: `/timber/api/internal/client_companies/${id}`,
        method: 'PATCH',
        body: { isActive },
      }),
      invalidatesTags: (result, error, params) => {
        if (!result) {
          return [{ type: eAPITags.ClientCompanyData, id: 'LIST' }];
        }
        return [
          { type: eAPITags.ClientCompanyData, id: result.id },
          { type: eAPITags.ClientCompanyData, id: 'LIST' },
        ];
      },
    }),
  }),
  overrideExisting: false,
});

export const { useListClientsQuery, useUpdateClientMutation } = ClientCompanyApi;
